import * as SentryReact from "@sentry/react";
import * as SentryExpo from "@sentry/react-native";
import { Platform } from "react-native";

export function handleErrors(data: any, onError?: (errors: any) => void) {
  if (data.errors) {
    data.errors.forEach((error: any) => {
      if (onError) onError(error);
      if (Platform.OS === "web") {
        SentryReact.captureException("error in gql", error);
      } else {
        SentryExpo.captureException("error in gql", error);
      }
    });
  }
}
